<mat-dialog-content class="modal-dialog">
  <div class="modal-content" style="height: 100%">
    <div class="modal-header buzon justify-content-center">
      <h2 class="modal-title fw-medium text-center">
        {{ '$contact' | translate }}
      </h2>
      <span class="position-absolute end-0 dismiss-modal" (click)="dialogRef.close()">X</span>
    </div>
    <div class="modal-body py-0 mt-3">
      <div class="row" style="height: 100%">
        <div class="col-12">
          @if (phone()) {
            <p class="text-center">
              {{ 'about_to_open' | translate }}
              <strong class="yellow-text">web.whatsapp.com</strong>
              {{ 'contact_service_provider' | translate }}
            </p>
            <button class="yellow full fw-normal" (click)="goToWhatsApp()">
              {{ '$continuar' | translate }}
            </button>
          } @else {
            <p class="text-center">
              {{ 'description.no_phone_available' | translate }}
            </p>
          }
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
